import AttachmentViewer from "components/organisms/AttachmentViewer";

/**
 * Backward-compatible wrapper around the unified {@link AttachmentViewer}.
 *
 * Historically this was a standalone full-screen lightbox. It now delegates to
 * AttachmentViewer so every entry point shares the same consistent experience
 * (overlay / modal / side panel / floating window, carousel, zoom, PII
 * auto-close and a remembered default mode). Existing props are preserved.
 */
const AttachmentLightbox = ({ visible, files = [], currentIndex = 0, onClose, onDownload, className = "", ...rest }) => (
    <AttachmentViewer
        visible={visible}
        files={files}
        currentIndex={currentIndex}
        onClose={onClose}
        onDownload={onDownload}
        className={className}
        {...rest}
    />
);

export default AttachmentLightbox;
